// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"bb741919","605":"a8924099","809":"62452d41","981":"3eacd799"}[chunkId] + ".chunk.js";
};